import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { DesabonnementService, CancelSubscriptionRequest, CancelSubscriptionResponse } from '../services/desabonnement.service';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-unsubscribe',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HeaderComponent, FooterComponent],
  templateUrl: './unsubscribe.component.html',
  styleUrl: './unsubscribe.component.scss'
})
export class UnsubscribeComponent implements OnInit {
  unsubscribeForm: FormGroup;
  isLoading = false;
  successMessage = '';
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private desabonnementService: DesabonnementService,
    private meta: Meta,
    private title: Title
  ) {
    this.unsubscribeForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    // Définir le titre de la page (48 caractères - optimal)
    this.title.setTitle('Résilier mon abonnement – pdf-to-word.fr');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Résiliez votre abonnement pdf-to-word.fr en toute simplicité. Annulez votre abonnement de conversion PDF en Word à tout moment depuis cette page.' });
    this.meta.updateTag({ name: 'keywords', content: 'résilier abonnement pdf-to-word, annuler abonnement PDF Word, désabonnement conversion PDF, résiliation service PDF Word' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Résilier mon abonnement – pdf-to-word.fr' });
    this.meta.updateTag({ property: 'og:description', content: 'Résiliez votre abonnement pdf-to-word.fr en toute simplicité. Annulez votre abonnement de conversion PDF en Word à tout moment depuis cette page.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
  }

  onSubmit(): void {
    if (this.unsubscribeForm.valid) {
      this.isLoading = true;
      this.successMessage = '';
      this.errorMessage = '';

      const formData = this.unsubscribeForm.value;
      const cancelRequest: CancelSubscriptionRequest = {
        id_site: 6, // ID du site pour le service de conversion PDF
        email: formData.email,
        origine: 'WEBSITE',
        raison: 'Résiliation demandée via le site web'
      };

      console.log('Envoi de la demande d\'annulation:', cancelRequest);

      this.desabonnementService.cancelSubscription(cancelRequest).subscribe({
        next: (response: CancelSubscriptionResponse) => {
          this.isLoading = false;
          
          if (!response.success) {
            this.errorMessage = 'Une erreur est survenue lors de l\'annulation. Veuillez contacter le support.';
            return;
          }

          if (response.data.status === 'cancelled') {
            this.successMessage = 'Votre abonnement a été annulé avec succès. Un email de confirmation vous sera envoyé.';
            this.unsubscribeForm.reset();
          } else if (response.data.status === 'already_unsubscribed') {
            this.successMessage = 'Votre abonnement a déjà été résilié. Aucune action supplémentaire n\'est nécessaire.';
            this.unsubscribeForm.reset();
          } else {
            this.errorMessage = response.data.message || 'Une erreur est survenue lors de l\'annulation. Veuillez contacter le support.';
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Erreur lors de l\'annulation:', error);
          this.errorMessage = 'Une erreur technique est survenue. Veuillez réessayer plus tard ou contacter le support.';
        }
      });
    } else {
      // Marquer tous les champs comme touchés pour afficher les erreurs de validation
      Object.keys(this.unsubscribeForm.controls).forEach(key => {
        this.unsubscribeForm.get(key)?.markAsTouched();
      });
    }
  }
}
